module.exports = __webpack_public_path__ + "static/media/ploni-light-aaa.f88a484a.eot";